module.exports = __webpack_public_path__ + "static/media/Music Animation.3faba397.gif";